export const COLORS = [
  // 메인 칼라
  {
    key: "colorMain100", className: "color-main-100", color: "#367AFF", label: "primary",
    colorName: "main", colorValue: '100'
  },
  {
    key: "colorMain80", className: "color-main-80", color: "#5E95FF", label: "",
    colorName: "main", colorValue: '80'
  },
  {
    key: "colorMain50", className: "color-main-50", color: "#99BBFD", label: "",
    colorName: "main", colorValue: '50'
  },
  {
    key: "colorMain10", className: "color-main-10", color: "#EBF2FF", label: "",
    colorName: "main", colorValue: '10'
  },
  {
    key: "colorMain5", className: "color-main-5", color: "#F5F8FF", label: "",
    colorName: "main", colorValue: '5'
  },

  // 퍼플 210525 추가
  {
    key: "colorPurple100", className: "color-purple-100", color: "#5C6DFF",
    colorName: "purple", colorValue: '100'
  },
  {
    key: "colorPurple80", className: "color-purple-80", color: "#7D8AFF",
    colorName: "purple", colorValue: '80'
  },
  {
    key: "colorPurple50", className: "color-purple-50", color: "#AEB6FF",
    colorName: "purple", colorValue: '50'
  },
  {
    key: "colorPurple10", className: "color-purple-10", color: "#EFF0FF",
    colorName: "purple", colorValue: '10'
  },
  {
    key: "colorPurple5", className: "color-purple-5", color: "#F7F8FF",
    colorName: "purple", colorValue: '5'
  },

  // 그레이 2021.03.16 수정
  {
    key: "colorGray0", className: "color-gray-0", color: "#F8F9FB", label: "",
    colorName: "gray", colorValue: '0'
  },
  {
    key: "colorGray1", className: "color-gray-1", color: "#F1F4F8", label: "",
    colorName: "gray", colorValue: '1'
  },
  {
    key: "colorGray2", className: "color-gray-2", color: "#EAEEF3", label: "",
    colorName: "gray", colorValue: '2'
  },
  {
    key: "colorGray3", className: "color-gray-3", color: "#DEE4EB", label: "",
    colorName: "gray", colorValue: '3'
  },
  {
    key: "colorGray4", className: "color-gray-4", color: "#D1D8E4", label: "",
    colorName: "gray", colorValue: '4'
  },
  {
    key: "colorGray5", className: "color-gray-5", color: "#ABB5C6", label: "",
    colorName: "gray", colorValue: '5'
  },
  {
    key: "colorGray6", className: "color-gray-6", color: "#8591A6", label: "",
    colorName: "gray", colorValue: '6'
  },
  {
    key: "colorGray7", className: "color-gray-7", color: "#4A5673", label: "secondary",
    colorName: "gray", colorValue: '7'
  },
  {
    key: "colorGray8", className: "color-gray-8", color: "#334060", label: "",
    colorName: "gray", colorValue: '8'
  },
  {
    key: "colorGray9", className: "color-gray-9", color: "#0C2048", label: "",
    colorName: "gray", colorValue: '9'
  },

  // 그린 2021.03.16 수정
  //2021.06.08 수정
  {
    key: "colorGreen100", className: "color-green-100", color: "#21D4A9", label: "success",
    colorName: "green", colorValue: '100'
  },
  {
    key: "colorGreen80", className: "color-green-80", color: "#4DDDBA", label: "",
    colorName: "green", colorValue: '80'
  },
  {
    key: "colorGreen50", className: "color-green-50", color: "#90E9D4", label: "",
    colorName: "green", colorValue: '50'
  },
  {
    key: "colorGreen10", className: "color-green-10", color: "#E9FBF6", label: "",
    colorName: "green", colorValue: '10'
  },
  {
    key: "colorGreen5", className: "color-green-5", color: "#F4FDFB", label: "",
    colorName: "green", colorValue: '5'
  },

  // 오렌지 2021.03.16 수정
  //2021.06.08 수정
  {
    key: "colorOrange100", className: "color-orange-100", color: "#FF9C00", label: "warning",
    colorName: "orange", colorValue: '100'
  },
  {
    key: "colorOrange80", className: "color-orange-80", color: "#FFB033", label: "",
    colorName: "orange", colorValue: '80'
  },
  {
    key: "colorOrange50", className: "color-orange-50", color: "#FFCD80", label: "",
    colorName: "orange", colorValue: '50'
  },
  {
    key: "colorOrange10", className: "color-orange-10", color: "#FFF5E6", label: "",
    colorName: "orange", colorValue: '10'
  },
  {
    key: "colorOrange5", className: "color-orange-5", color: "#FFFAF2", label: "",
    colorName: "orange", colorValue: '5'
  },

  // 레드 2021.03.16 수정
  //2021.06.08 수정
  {
    key: "colorRed100", className: "color-red-100", color: "#FF5C6D", label: "danger",
    colorName: "red", colorValue: '100'
  },
  {
    key: "colorRed80", className: "color-red-80", color: "#FF7D8A", label: "",
    colorName: "red", colorValue: '80'
  },
  {
    key: "colorRed50", className: "color-red-50", color: "#FFADB6", label: "",
    colorName: "red", colorValue: '50'
  },
  {
    key: "colorRed10", className: "color-red-10", color: "#FFEFF0", label: "",
    colorName: "red", colorValue: '10'
  },
  {
    key: "colorRed5", className: "color-red-5", color: "#FFF7F8", label: "",
    colorName: "red", colorValue: '5'
  },
]

export const COLOR = {}
COLORS.forEach(({ color, colorName, colorValue }) => {
  const name = colorName.toUpperCase()
  if (!COLOR[name]) {
    COLOR[name] = {}
  }
  COLOR[name][colorValue] = color
})